import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import theme from './modules/theme'
import admin from "./modules/admin";
import historyMessage from "@/store/modules/historyMessage";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        admin,
        app,
        settings,
        theme,
        historyMessage,
    },
    getters
});

export default store;